import React from "react";
import { Link } from "react-router-dom";
import { Splide, SplideTrack, SplideSlide } from '@splidejs/react-splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';
import "@splidejs/splide/dist/css/splide.min.css";
// encrypted_id : "eyJpdiI6IjZMQm00b2xoY3VVcjVrSDczaWNLdXc9PSIsInZhbHVlIjoiOGMxYkpBTEp4b3ZjOU9ybE93VVlZUT09IiwibWFjIjoiYjAyZjZkZWRmODM2MGU0MmMxY2MyOTQ5ZDAyNWYwNTE4MTVkNjkxZDE1ZTEyM2MwYTljOWVmZDExZWI4YzIyMyIsInRhZyI6IiJ9"
// nama_activity : "PMR WIRA"
// short_desc_activity : "Ini Contoh Testing Tambah Deskripsi singkat tentang ekstrakulikuler PMR WIRA"
// url_logo : "logo_KpxZVACM1641563320.png"
const ExtraSection = ({ listExtra }) => {
    return (
        <section id="extra" className="py-10 bg-blue-100">
            <div className="container px-5 mx-auto">
                <div className="mb-10 text-center">
                    <h2 className="text-5xl font-bold uppercase">Extra</h2>
                    <p className="mt-5 text-gray-500">Some extra in Smandapura</p>
                </div>
                <div className="relative">
                    <Splide
                        options={{
                            type: 'loop',
                            perPage: 3, // Default: 3 per page
                            breakpoints: {
                                1024: { perPage: 2 }, // md: 2 per page
                                620: { perPage: 1 }    // sm: 1 per page
                            },
                            drag: "free",
                            gap: "1rem",
                            autoScroll: {
                                pauseOnHover: true,
                                pauseOnFocus: false,
                                speed: 1
                            },
                            arrows: false,
                        }}
                        aria-label="Extra Activities"
                        extensions={{ AutoScroll }}
                        hasTrack={false}
                    >
                        <SplideTrack>

                            {listExtra.map((item) => (
                                <SplideSlide key={item.encrypted_id}>
                                    <div key={item.encrypted_id} className="overflow-hidden relative h-full bg-white rounded-lg shadow-md extra-item group">
                                        <div className="relative">
                                            <Link
                                                to={`/extra/${item.encrypted_id}`}
                                                className="block overflow-hidden"
                                            >
                                                <div className="flex absolute inset-0 justify-center items-center bg-black bg-opacity-50 opacity-0 transition duration-300 extra-hover group-hover:opacity-100">
                                                    <div className="text-center text-white">
                                                        <p className="text-sm">{item.short_desc_activity}</p>
                                                    </div>
                                                </div>
                                                <img
                                                    src={`https://admin.sman2amlapura.sch.id/images/Activity/${item.url_logo}`}
                                                    alt={item.nama_activity}
                                                    className="object-cover w-full h-64 aspect-square"
                                                />
                                            </Link>
                                        </div>
                                        <div className="p-4">
                                            <h4 className="text-xl font-semibold text-gray-800 font-montserrat">{item.nama_activity}</h4>
                                            <p className="mt-2 text-sm text-gray-600 font-droid">
                                                {item.short_desc_activity}
                                            </p>
                                        </div>
                                    </div>

                                </SplideSlide>
                            ))}
                        </SplideTrack>
                    </Splide>
                </div>
                <div className="mt-10 text-center">
                    <Link
                        to={`/extra`}
                        className="px-4 py-2 text-white bg-blue-600 rounded transition hover:bg-blue-700"
                    >
                        See Extra
                    </Link>
                </div>
            </div>
        </section>
    );
};

export default ExtraSection;
